<section class="teams" id="mannschaften" [classList]="show ? 'teams show' : 'teams'" #opening>
  <h3>
    Unsere Dart <span>Mannschaften</span>
  </h3>
  <p>
    Hier findest du eine Übersicht unserer Dart-Mannschaften mit allen wichtigen Infos zu ihrer Liga, aktuellen Platzierung und den neuesten Tabellenständen.
  </p>

  <ul>
    <ng-container *ngFor="let team of currentTeams">
      <li>
        <div *ngIf="!team.league" class="loading">
          <div class="loader"></div>
        </div>
        <div class="team" *ngIf="team.league">
          <picture>
            <source srcset="assets/images/dart.webp" type="image/webp">
            <img src="assets/images/dart.png" alt="{{team.name}}">
          </picture>
          <p>
            <b>{{team.name}}</b><br>
            Liga: {{getLeagueType(team)}}<br>
            Klasse: {{team.league}}<br>
          </p>
        </div>
      </li>
    </ng-container>
  </ul>
</section>
